import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";

const SUB_TABS = [
  { id: "create", path: "/papers/create", icon: "fa-solid fa-file-circle-plus", label: "Create Paper" },
  { id: "saved", path: "/papers/saved", icon: "fa-solid fa-folder-open", label: "Saved Papers" },
];

function getActiveSubTab(pathname) {
  if (pathname.includes("/saved")) return "saved";
  return "create";
}

export default function PapersLayout() {
  const location = useLocation();
  const activeSubTab = getActiveSubTab(location.pathname);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: 'var(--header-height)',
      left: 0,
      right: 0,
      bottom: 0,
      minHeight: 0
    }}>
      {/* Sub-tab Navigation */}
      <div className="subnav" style={{ flexShrink: 0 }}>
        {SUB_TABS.map((tab) => (
          <NavLink
            key={tab.id}
            to={tab.path}
            className={`subnav-tab ${activeSubTab === tab.id ? "active" : ""}`}
          >
            <i className={tab.icon}></i>
            {tab.label}
          </NavLink>
        ))}
      </div>

      {/* Content Area */}
      {/* minHeight 0 lets this pane scroll instead of sizing to max-content,
          which was clipping the download menu under the cards. */}
      <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '20px' }}>
        <Outlet />
      </div>
    </div>
  );
}
